jQuery(document).ready(function($) {
    
	function returnTop() {
		if($(document).scrollTop() > $(window).height()) {
			$('#return-top').addClass('active');
		} else {
			$('#return-top').removeClass('active');
		}
	}
	returnTop();

	$(window).resize(function() {
		returnTop();
	});

	$(window).scroll(function() {
		returnTop();
	});
 
});
